import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";
import { styled } from "@mui/system";

export const MultiAccountListStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      height: "auto",
      width: "100%",
      backgroundColor: "#FFFFFF",
      boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.25)",
      borderRadius: "12px",
      marginTop: "27px",
      marginLeft: "20px",
      padding: "20px",

      "&:after": {
        content: "''",
        position: "absolute",
        width: "25px",
        height: "25px",
        background: "#FFFFFF",
        transform: "rotate(227deg)",
        top: "15px",
        left: "339px",
        zIndex: 1,
        boxShadow: "5px 5px 6px rgba(0, 0, 0, 0.15), -2px -2px 3px #FFF",
        border: "solid transparent",
        // border: "1px solid red",
      },
    },

    clientListContainer: {
      width: "100%",
    },

    clientListItem: {
      // border: "1px solid red",
      display: "flex",
      marginBottom: "10px",
      cursor: "pointer",
      "& :hover": {
        backgroundColor: "#f5f5f5",
      },
    },

    accountPicture: {
      width: "40px",
      height: "40px",
      borderRadius: "50%",
    },

    onlineStatus: {
      width: "52px",
      height: "52px",
      borderRadius: "100px",
      border: "2px solid #0BEC9F",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },

    offlineStatus: {
      width: "52px",
      height: "52px",
      borderRadius: "100px",
      border: "2px solid #BDC2C5",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },

    primaryText: {
      fontWeight: 700,
    },

    secondaryText: {
      fontSize: "12px",
      fontWeight: 600,
    },

    hrStyles: {
      width: "100%",
      border: "1px solid #f3f4f5",
    },

    linkContainer: {
      paddingBottom: "10px",

      "&:last-child": {
        paddingBottom: "0px",
      },
    },

    link: {
      fontSize: "14px",
      color: "#000",
      textDecoration: "none",
      cursor: "pointer",
    },
  }),
);

export const BrokerProfileWrapper = styled("button")(({ disabled }) => ({
  display: "flex",
  alignItems: "flex-start",
  gap: "8px",
  background: "transparent",
  outline: "none",
  border: "none",
  cursor: disabled ? "default" : "pointer",
  padding: "0px",

  "&:hover": {
    background: disabled ? "transparent" : "#F8F9F9",
  },
}));

export const ImageFrameWrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "flex-start",
}));

interface BrokerProfileCircleProps {
  isOnline?: boolean;
  isGuest?: boolean;
}
export const BrokerProfileCircle = styled("div")<BrokerProfileCircleProps>(({ isOnline }) => ({
  width: "35px",
  height: "35px",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "100px",
  border: isOnline ? "1px solid #0BEC9F" : "1px solid #FCD34D",
  background: "#FFF",
}));

interface GuestIconWrapperProps {
  isGuest: boolean;
}
export const GuestIconWrapper = styled("div")<GuestIconWrapperProps>(({ isGuest, theme }) => ({
  padding: "8px",
  justifyContent: "center",
  alignItems: "center",
  gap: "4px",
  borderRadius: "20px",
  background: theme.palette.secondary.contrastText,
  display: isGuest ? "flex" : "none",
}));

export const FlagIconWrapper = styled("div")(() => ({
  display: "flex",
  padding: "1px",
  justifyContent: "center",
  alignItems: "center",
  position: "relative",
  top: 0,
  right: 0,
}));

export const FlagIconPositioning = styled("div")(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  position: "absolute",
  top: 22,
  right: 0,
  width: "15px",
  height: "15px",
  borderRadius: "50%",
}));

export const BrokerTextWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  alignSelf: "stretch",
}));

export const BrokerNameWrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "8px",
  alignSelf: "stretch",
}));

interface BrokerTextProps {
  color: string;
  fontSize: string;
  lineHeight: string;
  bold?: boolean;
}
export const BrokerText = styled("div")<BrokerTextProps>(
  ({ color, fontSize, bold, lineHeight }) => ({
    color: color,
    fontFamily: "Söhne",
    fontSize: fontSize,
    fontStyle: "normal",
    fontWeight: bold ? 600 : 400,
    lineHeight: lineHeight,
  }),
);
